// TODO: Migrate Obb/helpers/resolveObbStationCoords to this shared helper.

/** Resolves lat/lng from transport stop objects returned by the info/estimation APIs. */
export const resolveTransportStopCoords = (stop: any): { lat: number; lng: number } | null => {
  const lat = typeof stop?.latitude === "number" ? stop.latitude : stop?.location?.lat;
  const lng = typeof stop?.longitude === "number" ? stop.longitude : stop?.location?.lon;

  if (typeof lat !== "number" || typeof lng !== "number") {
    return null;
  }

  return { lat, lng };
};
